var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"raw__content"}},[_c('h2',{staticClass:"content__title"},[_vm._v("\n    Materias primas\n  ")]),_vm._v(" "),_c('div',{staticClass:"cards"},_vm._l((_vm.products),function(product){return (product.category === 'raw')?_c('carousel-card',{key:product.id,attrs:{"product":product}}):_vm._e()}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }